import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getContactDeals, addDeal, editDeal } from '../../actions/deal';
import DatePicker from 'react-date-picker';
import { makeStyles, Link } from '@material-ui/core';
import moment from 'moment';
import AddDeal from './AddDeal';
import OneDeal from './OneDeal';

// const initialState = {
//   _id: '',
//   name: '',
//   amount: '',
//   note: '',
//   time: ''
// };

const ViewDeal = ({
  getContactDeals,
  addDeal,
  editDeal,
  contact: { deals },
  contactID
}) => {
  const useStyles = makeStyles(theme => ({
    root: {
      margin: '1em 0 1em 0',
      color: '#333'
    },
    body: {},
    addButtonDiv: {
      marginBottom: '15px'
    },
    addButton: {
      marginRight: '15px'
    },
    dealContainer: {
      background: '#F2F4F4',
      marginBottom: '10px'
    },
    newDealBody: {
      padding: '5px',
      background: '#F2F4F4'
    },
    dealNameHead: {
      padding: '5px',
      background: '#D5D8DC',
      fontSize: '1rem'
    },
    dealFooter: {
      margin: '5px',
      display: 'flex'
    },
    timeLine: {
      paddingTop: '2px'
    },
    noteBody: {
      margin: '15px 0 5px 5px'
    }
  }));

  const classes = useStyles();
  // const [clickEdit, setClickEdit] = useState(false);
  const [clickNew, setClickNew] = useState(false);

  const [timeValue, onChange] = useState(new Date());

  // const [formDataEdit, setFormDataEdit] = useState(initialState);
  const [formDataNew, setFormDataNew] = useState({
    nameNew: '',
    amountNew: '',
    noteNew: '',
    timeNew: ''
  });

  const onClickNewCancel = e => {
    e.preventDefault();
    setClickNew(false);
  };

  const { nameNew, amountNew, noteNew } = formDataNew;

  const onChangeInputNew = e =>
    setFormDataNew({ ...formDataNew, [e.target.name]: e.target.value });

  const onSubmitNew = e => {
    e.preventDefault();
    let difference = moment().diff(moment(timeValue), 'seconds');
    if (difference < 0) {
      formDataNew.time = timeValue;
      addDeal(formDataNew, contactID);
      setClickNew(false);
    }
    setFormDataNew({ nameNew: '', amountNew: '', noteNew: '', timeNew: '' });
  };

  useEffect(() => {
    getContactDeals(contactID);
  }, [getContactDeals]);

  return (
    <div className={classes.root}>
      <div className={classes.body}>
        <div className={classes.addButtonDiv}>
          <AddDeal key={contactID} contactID={contactID} />
        </div>
        <div>
          {deals.length > 0 ? (
            <Fragment>
              {deals.map(deal => (
                <Fragment>
                  <OneDeal key={deal._id} deal={deal} />
                </Fragment>
              ))}
              <Fragment>
                {clickNew && (
                  <div className={classes.newDealBody}>
                    <h3>New Deal</h3>{' '}
                    <div>
                      <DatePicker onChange={onChange} value={timeValue} />
                    </div>
                    <form className='na-form' onSubmit={e => onSubmitNew(e)}>
                      <div className='form-group'>
                        <input
                          type='text'
                          placeholder='Deal'
                          name='nameNew'
                          value={nameNew}
                          onChange={e => onChangeInputNew(e)}
                          required
                        />
                      </div>
                      <div className='form-group'>
                        <input
                          type='number'
                          placeholder='Amount'
                          name='amountNew'
                          value={amountNew}
                          onChange={e => onChangeInputNew(e)}
                          required
                        />
                      </div>
                      <div className='form-group'>
                        <input
                          type='text'
                          placeholder='Note'
                          name='noteNew'
                          value={noteNew}
                          onChange={e => onChangeInputNew(e)}
                        />
                      </div>
                      <input
                        type='submit'
                        className='btn btn-firm'
                        value='Save'
                      />
                      <Link href='#' onClick={e => onClickNewCancel(e)}>
                        Cancel
                      </Link>
                    </form>
                  </div>
                )}
              </Fragment>
            </Fragment>
          ) : (
            <Fragment></Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

ViewDeal.propTypes = {
  addDeal: PropTypes.func.isRequired,
  editDeal: PropTypes.func.isRequired,
  getContactDeals: PropTypes.func.isRequired,
  contact: PropTypes.object.isRequired,
  contactID: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  contact: state.contact
});

export default connect(mapStateToProps, { getContactDeals, addDeal, editDeal })(
  ViewDeal
);



// WEBPACK FOOTER //
// ./src/components/deal/ViewDeal.js